import { render, staticRenderFns } from "./ontick-error-screen.component.vue?vue&type=template&id=f623e9c8&scoped=true"
import script from "./ontick-error-screen.component.vue?vue&type=script&lang=js"
export * from "./ontick-error-screen.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-error-screen.component.vue?vue&type=style&index=0&id=f623e9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f623e9c8",
  null
  
)

export default component.exports